import { forwardRef } from "react";
import { motion } from "framer-motion";

export const AnimatedGradientBorder = forwardRef<
  HTMLDivElement,
  { children: React.ReactNode; className?: string }
>(({ children, className = "" }, ref) => {
  return (
    <div ref={ref} className={`relative ${className}`}>
      <motion.div
        className="absolute -inset-[1px] rounded-[inherit] z-0"
        style={{
          background:
            "linear-gradient(135deg, rgba(161,161,170,0.5) 0%, transparent 40%, transparent 60%, rgba(113,113,122,0.28) 100%)",
        }}
        animate={{
          background: [
            "linear-gradient(135deg, rgba(161,161,170,0.5) 0%, transparent 40%, transparent 60%, rgba(113,113,122,0.28) 100%)",
            "linear-gradient(225deg, rgba(161,161,170,0.5) 0%, transparent 40%, transparent 60%, rgba(113,113,122,0.28) 100%)",
            "linear-gradient(315deg, rgba(161,161,170,0.5) 0%, transparent 40%, transparent 60%, rgba(113,113,122,0.28) 100%)",
            "linear-gradient(135deg, rgba(161,161,170,0.5) 0%, transparent 40%, transparent 60%, rgba(113,113,122,0.28) 100%)",
          ],
        }}
        transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
      />
      <div className="relative z-10 h-full">{children}</div>
    </div>
  );
});
